import { render } from "./CreateUnitModal.vue?vue&type=template&id=0b94fe2e"
import script from "./CreateUnitModal.vue?vue&type=script&lang=js"
export * from "./CreateUnitModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__